import { METHOD, NEW_POLICIES_START_DATE, PMFBY, pmfby, VENDOR_MANAGER } from "../consts"
import { axiosClient, axiosRequest, axiosWithoutToken } from "../service"
import { CLAIM_INGESTION_SERVICE, GIS_CMS_SERVICE, REACT_APP_CUSTOMER_ENDORSEMENT_INFORMATION_SHEET, REACT_APP_IMAGE_GEO_TAG, REACT_APP_IMAGE_GEO_TAG_CLAIM, REACT_APP_KSHEMA_POC1, REACT_APP_KSHEMA_POC2, WRAPPER_SERVICE, REACT_APP_PROPOSAL_CKYC_LAND_FORM, REACT_APP_TENANT_FORM, REACT_APP_VAM_CONTEXT_DOCUMENT, REACT_APP_VAM_CONTEXT_FIELD, REACT_APP_VAM_CONTEXT_GIS, REACT_APP_VAM_CONTEXT_INGESTION, REACT_APP_VAM_CONTEXT_PHOTO_COORDINATE, REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_CONTEXT_SURVEYOR, REACT_APP_VAM_ENDPOINT, KSHEMA_OLD_DOCUMENTS_URL} from "../urls"
import { encryptValue, saveInLocalStorage, clearCookieKeys, getFileExtensionType } from "../utilFunctions"
import { toast } from "react-toastify"

export const getCalamityNames = ({
  setCalamityNames,
  setCalamityType,
  claimDetailCookie,
  toast,
  setCalamity,
  setCalamityTypes,
},type) => {
  axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)({
    method: METHOD.GET,
    url: "getCalamityMaster",
  })
    .then((data) => {
      // toast.success("Claim Created Successfully.")
      if (setCalamityNames) {
        setCalamityNames(
          data?.data?.map((list) => {
            return {
              label: list.name,
              value: list.id,
            };
          })
        );
      }
      if (setCalamityType && claimDetailCookie) {
        const selectedValue = data.data.find(
          (option) => option.id === claimDetailCookie?.productType
        );
        setCalamityType(selectedValue);
      }
      if (setCalamity) {
        setCalamity(data.data);
      }
      if (setCalamityTypes) {
        const calamityData= type?.value === 'Individual' ?  data?.data?.filter(item => item.name === 'Localized' || item.name === 'Post Harvest' || item.name === 'Wide Spread Post Harvest' || item.name === 'Wide Spread Localized')  : type?.value === 'Area Based'? data.data.filter(item => item.name !== 'Localized' && item.name !== 'Post Harvest' && item.name !== 'Wide Spread Post Harvest' && item.name !== 'Wide Spread Localized') :  data.data;
        setCalamityTypes(
          calamityData.map((list) => {
            return {
              id: list.id,
              label: list.name,
              value: list.name,
            };
          })
        );
      }
    })
    .catch((error) => {
      console.error(error);
      if (toast);
      toast?.error("Something Went Wrong.");
    });
};
export const getPortalNames = ({
  setPortalType,
  claimDetailCookie,
  setPortalList,
}) => {
  axiosClient(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}`)({
    url: "getPortalMaster",
    method: METHOD.GET,
  })
    .then((data) => {
      if (setPortalType) {
        const selectedValue = data.data.find(
          (option) => option.id === claimDetailCookie?.portalCode
        );
        setPortalType(selectedValue);
      }
      if (setPortalList) {
        setPortalList(data.data);
      }
    })
    .catch((error) => {});
};

const sortStatesAlphabetically = (states) => {
  return [...states].sort((a, b) => a.localeCompare(b));
};

export const fetchStates = async (productID) => {
  const baseUrl= productID == pmfby ? REACT_APP_KSHEMA_POC2 : WRAPPER_SERVICE
  try {
    const response = await axiosClient(`${baseUrl}`)({
      url: `states${productID === pmfby ? '/pmfby':''}`,
      method: METHOD.GET
    })
    const states = response.data.States;
    const flattenedStates = Array.isArray(states) ? states.flat(Infinity) : [];
    const sortedStates = sortStatesAlphabetically(flattenedStates);
    const mappedStates = sortedStates.map((state) => ({
      label: state,
      value: state,
    }));
    return mappedStates;
  } catch (error) {
    console.error("Error fetching states:", error);
    return [];
  }
};

export const fetchDistricts = async (state, productID) => {
  const baseUrl = productID == pmfby ? REACT_APP_KSHEMA_POC2 : WRAPPER_SERVICE
  try {
    const response = await axiosClient(`${baseUrl}`)({
      url: `districts${productID === pmfby ? '/pmfby' : ''}/${state}`,
      method: METHOD.GET
    })
    return response.data.Districts.flat("Infinity").sort().map(list => {
      return {
        label: list,
        value: list
      }
    })  

  } catch (error) {
    console.error("Error fetching districts:", error);
    return [];
  }
};

export const fetchMandals = async (district, state, productID) => {
  const baseUrl = productID == pmfby ? REACT_APP_KSHEMA_POC2 : WRAPPER_SERVICE
  try {
    const response = await axiosClient(`${baseUrl}`)({
      url: `mandals${productID === pmfby ? '/pmfby' : ''}/${state}/${district}`,
      method: METHOD.GET
    })
    return response.data.Mandal.flat("Infinity").map(list => {
      return {
        label: list,
        value: list,
      };
    });
  } catch (error) {
    console.error("Error fetching mandals:", error);
    return [];
  }
};

export const fetchVillages = async (mandal, district, state, productID) => {
  const baseUrl= productID == pmfby ? REACT_APP_KSHEMA_POC2 : WRAPPER_SERVICE
  try {
    const response = await axiosClient(`${baseUrl}`)({
      url: `villages${productID === pmfby ? '/pmfby':''}/${state}/${district}/${mandal}`,
      method: METHOD.GET
    })
    return response.data.Villages.flat("Infinity").map(list => {
      return {
        label: list,
        value: list,
      };
    });
  } catch (error) {
    console.error("Error fetching villages:", error);
    return [];
  }
};

export const fetchPincodeList = async (village, mandal, district, state, setPincode) => {
  try {
    const response = await axiosClient(`${WRAPPER_SERVICE}`)({
      url: `pincode/${state}/${district}/${mandal}/${village}`,
      method: METHOD.GET,
    });
    if(setPincode) {
      setPincode(response.data.Pincode)
    }
    return response.data.Pincode.flat("Infinity").map((list) => {
      return {
        label: list,
        value: list,
      };
    });
  } catch (error) {
    console.error("Error fetching pincodes:", error);
    return [];
  }
};

export const handleFileChange = (
  event,
  doctypeName,
  key,
  isFileLoading,
  setIsFileLoading,
  toast,
  roleDataCookie,
  createVendorData,
  setCreateVendorData,
  setDocUrls
) => {
  if (isFileLoading) {
    return;
  }
  const fileInput = document.getElementById(doctypeName);
  const file = fileInput.files[0];
  if (!file) {
    setIsFileLoading(false);
    return;
  }
  const formData = new FormData();
  if (file) {
    const fileType = file.type;
    if (Number((file.size / (1024 * 1024)).toFixed(4)) > 50) {
      toast.error("File Size Should be Less Than 50MB.");
      return;
    }
    if (
      [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
        "application/pdf",
      ].includes(fileType)
    ) {
      formData.append("userId", String(roleDataCookie?.userID));
      formData.append("file", file);
      formData.append("docType", doctypeName);
      formData.append("tranId", "");
      setIsFileLoading(true);
      setCreateVendorData({
        ...createVendorData,
        [key]: { ...createVendorData[key], isFileLoading: true },
      });
      axiosClient(
        `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}`
      )({
        url: "upload",
        method: METHOD.POST,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((data) => {
          axiosClient(
            `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}`
          )({
            url: `${data.data}`,
            method: METHOD.GET,
          })
            .then((urlData) => {
              setCreateVendorData({
                ...createVendorData,
                [key]: { ...urlData.data, isFileLoading: false },
              });
              setDocUrls((prev) => ({ ...prev, [key]: urlData.data.docURL }));
            })
            .catch((error) => {
              toast.error("Something Went Wrong. ");
            })
            .finally(() => {
              setIsFileLoading(false);
              fileInput.value = ""; // Clear the file input
            });
        })
        .catch((error) => {
          toast.error("Something Went Wrong. ");
        });
    } else {
      toast.error("File should be Selected format");
      setIsFileLoading(false);
      fileInput.value = ""; // Clear the file input
      return;
    }
  } else {
    setIsFileLoading(false);
  }
};
export const getFieldSurveyData = async (fieldSurveyId, setFieldSurveyData, getLatitudeAndLongitude) => {
  try{
  const response = await axiosRequest()
    .post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/getFieldSurveyDataUsingFieldNo/${fieldSurveyId}`
    );
    saveInLocalStorage("field_id", encryptValue(JSON.stringify(response?.data)));
    if(setFieldSurveyData){
      setFieldSurveyData(response?.data);
    }
    if (getLatitudeAndLongitude) {
        response?.data?.jsonResponse?.geoCoordinatedOfTheAffectedField &&
          getLatitudeAndLongitude(
            response?.data?.jsonResponse?.geoCoordinatedOfTheAffectedField
              .replace("POLYGON((", "[")
              .replace("))", "]")
              .replace("[", "")
              .replace("]", "")
          );
      }
    return response;
  }catch(e){
    return null;
  }
};

export const getGisSurveyList = async (claimNo) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_GIS}/getGISSurveyData/${claimNo}`
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const getGisSurveyUsingGISNo = async (GisSurveyId) => {
  try {
    const response = axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_GIS}/getGISSurveyDataUsingGISNo/${GisSurveyId}`
    );
    return response;
  } catch (error) {
    return null;
  }
};
export const getFieldSurveyList = (claimNo) => {
  try {
    const response = axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_FIELD}/getFieldSurveyData/${claimNo}`
    );
    return response;
  } catch (err) {
    return null;
  }
};

export const getPolicyPolygon = async (policyDetailCookie) => {
  try {
    const response = await axiosWithoutToken().post(
      `${REACT_APP_KSHEMA_POC1}/${GIS_CMS_SERVICE}/polygonsearch`,
      {
        Policy_Num: policyDetailCookie.policy_number,
        product: policyDetailCookie.product_name,
      }
    );
    return response;
  } catch (err) {
    return null;
  }
};
export const getFieldSurveyImageCoordinates = async (imageNameArray) => {
  try {
    const response = await axiosRequest().get(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PHOTO_COORDINATE}`,
      {
        params: { photo_names: imageNameArray },
        paramsSerializer: { indexes: null },
      }
    );
    return response;
  } catch (err) {
    return null;
  }
};
export const startFieldSurveyImageCoordinatesService = async (imageNameArray) => {
  try {
    const response = await axiosWithoutToken().post(
      `${REACT_APP_KSHEMA_POC1}/${REACT_APP_IMAGE_GEO_TAG}`,
      { images_list: imageNameArray }
    );
    return response;
  } catch (err) {
    return null;
  }
};
export const startClaimIntimationImageCoordinatesService = async (claimId,images) => {
  try {
    const response = await axiosWithoutToken().post(
      `${REACT_APP_KSHEMA_POC1}/${REACT_APP_IMAGE_GEO_TAG_CLAIM}`,
      { claims_list: [claimId],
        images_list: images
       }
    );
    return response;
  } catch (err) {
    return null;
  }
};
export const saveFieldSurveyImageCoordinates = async (requestParam) => {
  try {
    const response = await axiosRequest().post(
      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PHOTO_COORDINATE}`,
      requestParam
    );
    return response;
  } catch (err) {
    return null;
  }
};

export const getUserFunctionalities = async (
  email,
  setFetchedRoleData,
  instance
) => {
  axiosClient(
    `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`
  )({
    url: "userinfo",
    method: METHOD.GET,
    params: { email: email },
  })
    .then((data) => {
      if (Number(data.data.userRoleMapping.cmsStatus) === 1) {
        axiosClient(
          `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`
        )({
          url: `roleByUserID/${email}`,
          method: METHOD.GET,
        })
          .then((roleData) => {
            axiosClient(
              `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}`
            )({
              url: `role/${data?.data.userRoleMapping?.roleID}`,
              method: METHOD.GET,
            })
              .then((functionalitiesData) => {
                if (roleData.data && functionalitiesData?.data?.status !== 0) {
                  const permissionsList =
                    functionalitiesData.data.roleFunctionalities;
                  let roleFunctionalitiesEncripted = encryptValue(
                    JSON.stringify(permissionsList)
                  );
                  let roleDataEncripted = encryptValue(
                    JSON.stringify({ ...data.data, roleName: roleData.data })
                  );
                  let isAuthenticated = encryptValue("true");
                  saveInLocalStorage(
                    "roleFunctionalities",
                    roleFunctionalitiesEncripted
                  );
                  saveInLocalStorage("isAuthenticated", isAuthenticated);
                  saveInLocalStorage("roleData", roleDataEncripted);
                  setFetchedRoleData(true);
                  if (roleData.data === VENDOR_MANAGER) {
                    axiosClient(
                      `${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_SURVEYOR}`
                    )({
                      url: "searchSurveyorAndQCMaster",
                      method: METHOD.POST,
                      data: {
                        email: email
                      },
                    })
                      .then((data) => {
                        saveInLocalStorage("vendorManagerDetails", encryptValue(
                          JSON.stringify(data?.data?.length ? data.data[0] : {})))
                      }).catch((error) => {
                        console.error(error)
                      })
                  }
                } else {
                  if(functionalitiesData?.data?.status === 0) {
                    toast.error("User Role is In-Active")
                    setTimeout(()=>{
                      clearCookieKeys();
                      instance.logoutRedirect();
                    },1000)
                    return;
                  }
                  clearCookieKeys();
                  instance.logoutRedirect();
                }
              })
              .catch((error) => {
                console.log(error);
              });
          })
          .catch((err) => {
            toast.error("Role Not Assigned");
          });
      } else {
        toast.error("User is In-Active");
        setTimeout(() => {
          clearCookieKeys();
          instance.logoutRedirect();
        }, 1000);
      }
    })
    .catch((error) => {
      console.error(error)
    });
};
export const getClaimDocuments = async (claimNo, isHealth = false) => {
  try {
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_DOCUMENT}${isHealth ? "/health": ""}/claim/${claimNo}`,{params:{isCmsRequest:true}});
    return response;
  } catch (error) {
    return null;
  }
};


export const fetchSinglePolicyDocument = async (docId) => {
    try {
        const response = await axiosWithoutToken().get(`${KSHEMA_OLD_DOCUMENTS_URL}/v1/policy-doc/${docId}`);
        return response.data; // Return the entire data object
    } catch (error) {
        throw error; // Re-throw to be handled by the caller
    }
};

export const fetchSingleCustomerPolicyDocument = async (docId) => {
  try {
    const response = await axiosWithoutToken().get(
      `${KSHEMA_OLD_DOCUMENTS_URL}/${REACT_APP_CUSTOMER_ENDORSEMENT_INFORMATION_SHEET}/get_doc/cis/${docId}/${docId}.pdf`
    ); 
    return response;
  } catch (error) {
    console.error("Error in fetchSingleCustomerPolicyDocument:", error);
    throw error;
  }
};

export const fetchProposalFormDocument = async (tran_id) => {
  try {
    const [formResponse, videoResponse] = await Promise.all([
      axiosWithoutToken().get(
        `${KSHEMA_OLD_DOCUMENTS_URL}/${REACT_APP_PROPOSAL_CKYC_LAND_FORM}/azure/azure_get/dpf/${tran_id}.pdf`
      ),
      axiosWithoutToken().get(
        `${KSHEMA_OLD_DOCUMENTS_URL}/${REACT_APP_PROPOSAL_CKYC_LAND_FORM}/azure/azure_get/dpfVideo/${tran_id}`
      )
    ]);

    return {
      formDocument: formResponse,
      videoDocument: videoResponse
    };
  } catch (error) {
    console.error("Error in fetchSingleProposalFormDocument:", error);
    throw error;
  }
};

export const fetchMultipleEndorsementDocument = async (endorsementBase, paddedIndex) => {
  try {
    const response = await axiosWithoutToken().get(
      `${KSHEMA_OLD_DOCUMENTS_URL}/${REACT_APP_CUSTOMER_ENDORSEMENT_INFORMATION_SHEET}/azure/azure_get/endorsements/${endorsementBase}_${paddedIndex}.pdf`
    );
    return response;
  } catch (error) {
    console.error(`Error fetching endorsement document ${paddedIndex}:`, error);
    throw error;
  }
};

export const fetchCKYCDocuments = async (params) => {
    try {
        const { farmer_id } = params;
        const response = await axiosWithoutToken().get(
            `${KSHEMA_OLD_DOCUMENTS_URL}/v1/farmer-doc/${farmer_id}`
        );
        return response;
    } catch (error) {
        console.error(`Error fetching CKYC documents:`, error);
        throw error;
    }
};

export const fetchLandDocuments = async (params) => {
    try {
        const queryString = `pid=${params.polygon_id}&records=${params.records ?? 2}`;

        const response = await axiosWithoutToken().get(
            `${KSHEMA_OLD_DOCUMENTS_URL}/${REACT_APP_PROPOSAL_CKYC_LAND_FORM}farmDetails/getFarmDetails?${queryString}`
        );
        return response
    } catch (error) {
        console.error(`Error fetching Land documents:`, error);
        throw error;
    }
};
export const getClaimsCreatedByList = ({setCreatedByList}) => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_INGESTION}/claims/created-by`)
    .then((res) => {
          const list = Array.isArray(res?.data) ? res.data : [];
          const options = list
            .filter((v) => typeof v === 'string' && v.trim())
            .map((v) => {
              const value = v.trim();
              return { label: value, value: value };
            });
          setCreatedByList(options);
        })
    .catch(error => {
          console.error(error)
      })
  };

export const getAdditionalQuestions = async () => {
  try {
    const response = await axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${CLAIM_INGESTION_SERVICE}/claimIngestion/questions`)
    return response?.data;

  } catch (error) {
    console.error("Error fetching additional questions:", error);
    return []
  }
};
export const getPerilList = async (productName, setPerilList, purchaseDate) => {
  const baseURL1 = REACT_APP_KSHEMA_POC2;
  const baseURL2 = WRAPPER_SERVICE;
  try {
    let responses = [];

    if (productName === PMFBY) {
      // Case 1: PMFBY → Only baseURL1
      const res = await axiosRequest().get(`${baseURL1}/perils/${productName}`);
      responses.push(res);
    } else if (purchaseDate) {
      // Case 2: purchaseDate exists
      const purchase = new Date(purchaseDate);
      const policyStart = new Date(NEW_POLICIES_START_DATE);

      if (purchase >= policyStart) {
        // On or after newPoliciesStartDate → Only baseURL2
        const res = await axiosRequest().get(`${baseURL2}/perils/${productName}`);
        responses.push(res);
      } else {
        // Before newPoliciesStartDate → Only baseURL1
        const res = await axiosRequest().get(`${baseURL1}/perils/${productName}`);
        responses.push(res);
      }
    } else {
      // Case 3: No purchaseDate → Call both APIs
      const results = await Promise.allSettled([
        axiosRequest().get(`${baseURL1}/perils/${productName}`),
        axiosRequest().get(`${baseURL2}/perils/${productName}`)
      ]);

      results.forEach((result) => {
        if (result.status === "fulfilled") {
          responses.push(result.value);
        } else {
          console.error("API failed:", result.reason);
        }
      });
    }

    // Combine peril data
    let combinedPerils = [];
    responses.forEach((data) => {
      if (data?.data?.major_perils) {
        combinedPerils.push(...data.data.major_perils, ...data.data.minor_perils);
      } else {
        combinedPerils.push(...Object.values(data.data)[0].flat(Infinity));
      }
    });

    // Remove duplicates
    const uniquePerils = [...new Set(combinedPerils)];

    // Format for dropdown
    const formattedPerils = uniquePerils.map((list) => ({
      label: list,
      value: list
    }));

    setPerilList(formattedPerils);
  } catch (error) {
    console.error("Unexpected error:", error);
  }
};